








































import { POSTicketDetail } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcPosPaymentBalanceDetails from './pos-payment-balance-details.vue';

@Component({
  name: 'bpc-pos-confirm-payment-modal',
  components: {
    BpcPosPaymentBalanceDetails,
  },
})
export default class PosConfirmPaymentModal extends Vue {
  // PROPS
  @Prop({ type: String, required: true })
  readonly paymentMethod: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly paymentAmount!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly contactId!: number;
  @Prop({ type: Object, required: true }) readonly ticketDetail: POSTicketDetail;

  // DATA
  savingPayment = false;

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.savingPayment = false;
    this.$emit('close');
  }

  async onConfirmPayment() {
    this.savingPayment = true;
    const ticket = await this.$posService.createPayment(
      this.posSessionId,
      this.ticketDetail.id,
      this.paymentAmount,
      this.paymentMethod,
      this.contactId,
    );

    this.$emit('ticket-detail-updated', ticket);

    // if (this.$posService.paymentMethodNeedsToWaitForExternalResponse(this.selectedPaymentMethod)) {
    //   this.showUpdatePaymentStatusButton = true;
    //   // TODO listen to the event
    //   const paymentEventsListener = this.$posService.listenPaymentEvents(
    //     this.posSessionId,
    //     this.currentTicketId,
    //     this.selectedPaymentMethod,
    //   );

    //   if (paymentEventsListener) {
    //     paymentEventsListener
    //       .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentCancelled', async data => {
    //         // console.log('getTerminalPaymentChannel listen event', data);
    //         const paymentInArray = this.ticketPayments.find(
    //           payment => payment.id === data.paymentId,
    //         );
    //         if (paymentInArray) {
    //           await this.getTicketDetail();
    //           this.savingPayment = false;
    //           this.showPaymentAlertMessage(
    //             'warning',
    //             'payment_terminals.modal.payment_status_cancelled',
    //           );
    //         }
    //       })
    //       .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentConfirmed', async data => {
    //         console.log('getTerminalPaymentChannel listen event', data);
    //         const paymentInArray = this.ticketPayments.find(
    //           payment => payment.id === data.paymentId,
    //         );
    //         if (paymentInArray) {
    //           await this.getTicketDetail();
    //           this.savingPayment = false;
    //           this.hideConfirmPaymentButton = true;
    //           this.showPaymentAlertMessage(
    //             'success',
    //             'payment_terminals.modal.payment_status_approved',
    //           );
    //         }
    //       })
    //       .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentBusy', data => {
    //         const paymentInArray = this.ticketPayments.find(
    //           payment => payment.id === data.paymentId,
    //         );
    //         if (paymentInArray) {
    //           this.showPaymentAlertMessage(
    //             'info',
    //             'payment_terminals.modal.payment_status_still_busy',
    //           );
    //         }
    //       });
    //   }
    // } else {
    this.savingPayment = false;
    this.$emit('success-payment');
    // }
  }
  // WATCHERS
}
